// extracted by mini-css-extract-plugin
export default {"cell":"Ticket_cell__NOlW-","flex":"Ticket_flex__UsYwp","block":"Ticket_block__me8JP"};